import WizardPagetemplate from '../../templates/WizardPagetemplate';
import { Grid, GridItem, LoadingDots } from '@flos/react-ui';
import CheckoutAccordion from './components/CheckoutAccordion';
import CheckoutSidebar from './components/CheckoutSidebar';
import { useHippoText } from '../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { externalCasesAtom } from '../../recoil/atoms/externalCasesAtom';
import { allCoverablesAtom } from '../../recoil/atoms/allCoverablesAtom';
import { getCheckoutConfig } from './configs/CheckoutAccordionConfig';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { jobInfoAtom } from '../../recoil/atoms/jobInfoAtom';

const CheckoutPage: WizardPageComponent = () => {
    const { wizardNextStep, wizardPreviousStep } = useWizardNavigation();
    const getHippoText = useHippoText();
    const coverables = useRecoilValue(allCoverablesAtom);
    const externalCasesData = useRecoilValue(externalCasesAtom);
    const { isPolicyChange } = useRecoilValue(jobInfoAtom);

    const checkoutAccordions = getCheckoutConfig(
        coverables,
        externalCasesData,
        isPolicyChange ?? false
    ).filter((accordion) => !accordion.disabled);

    if (checkoutAccordions.length === 0) {
        return <LoadingDots />;
    }

    return (
        <WizardPagetemplate
            onNext={wizardNextStep}
            onPrevious={wizardPreviousStep}
            hideNext
            hidePrevious
        >
            <Grid className={'u-shadow-none'}>
                <GridItem span={12}>
                    <h3>{getHippoText('DSS-CHECKOUT-HEADER')}</h3>
                </GridItem>
                <GridItem span={7}>
                    <CheckoutAccordion
                        wizardNextStep={wizardNextStep}
                        CheckoutAccordionConfig={checkoutAccordions}
                    />
                </GridItem>
                <GridItem colStart={9} span={4}>
                    <CheckoutSidebar />
                </GridItem>
            </Grid>
        </WizardPagetemplate>
    );
};

export default CheckoutPage;
